import { render } from "./DForm.vue?vue&type=template&id=e75f6554"
import script from "./DForm.vue?vue&type=script&lang=js"
export * from "./DForm.vue?vue&type=script&lang=js"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__